<template>
    <div class="page-container">
        <div class="tabbox">
            <div class="tabs">
                <div class="tab-item" :class="{actived:currentTab == 1}" @click="changeTab(1)">入库记录</div>
                <div class="tab-item" :class="{actived:currentTab == 2}" @click="changeTab(2)">出库记录</div>
            </div>
        </div>
        <template v-if="currentTab == 1">
            <div class="record-types">
                <div class="type-item" :class="{actived:currentFilter == 0}" @click="changeFilter(0)">全部</div>
                <div class="type-item" :class="{actived:currentFilter == 1}" @click="changeFilter(1)">进货记录</div>
                <div class="type-item" :class="{actived:currentFilter == 3}" @click="changeFilter(3)">销售奖励</div>
                <div class="type-item" :class="{actived:currentFilter == 2}" @click="changeFilter(2)">兑换推荐奖</div>
            </div>
            <div class="referral-line" v-if="currentFilter == 3">
                <!-- <span>已获取：{{totalNum}}箱</span> -->
                <span>待释放：{{releaseNum}}箱</span>
            </div>
        </template>
        <div class="page-bottom">
            
            <!-- 入库记录 -->
            <template v-if="currentTab == 1">
                <div class="purchase-block" v-for="(item,index) in list" :key="index" @click="jumpRk(item.orderId,item.opType)">
                    <div class="goods-bock">
                        <div class="item-top">
                            <span class="date">{{item.createTime | formatCreatetime}}</span>
                            <span class="status fromSale" v-if="item.opType == 3">「销售奖励」</span>
                            <span class="status fromPickup" v-if="item.opType == 1">「进货」</span>
                            <span class="status " style="color:#3037F5;" v-if="item.opType == 2">「兑换」</span>
                            <span class="status " style="color:#30DEF5;" v-if="item.opType == 4">「出库」</span>
                        </div>
                        <!-- 进货商品信息 -->
                        <div class="goods-info-block">
                            <img :src="item.picUrl" class="goods-pic">
                            <div class="goods-detail">
                                <div class="goods-name">
                                    <span>{{`${item.name} ${item.degree}度 ${item.capacity}`}}</span>
                                    <!-- <span>-{{item.amount}}元</span> -->
                                </div>
                                <div class="goods-sku">
                                    <span>整箱(6瓶)</span>
                                    <span style="color:#3088f5;">+{{item.num}}(瓶)</span>
                                </div>
                                <!-- <div class="caigou-price">采购价：¥288.9/瓶</div> -->
                            </div>
                        </div>
                        <!-- 该种酒总数 -->
                        <!-- <div class="goods-total">
                            <span class="total-num">{{item.remark}}</span>
                        </div> -->
                    </div>
                </div>
            </template>
            <!-- 出库记录 -->
            <template v-else>
                <div class="purchase-block" v-for="(item,index) in list" :key="index" @click="jumpCk(item.orderId)">
                    <div class="goods-bock">
                        <div class="item-top">
                            <span class="date">{{item.createTime | formatCreatetime}}</span>
                            <span class="status from-sale">「出库」</span>
                        </div>
                        <!-- 进货商品信息 -->
                        <div class="goods-info-block">
                            <img :src="item.picUrl" class="goods-pic">
                            <div class="goods-detail">
                                <div class="goods-name">
                                    <span>{{`${item.name} ${item.degree}度 ${item.capacity}`}}</span>
                                    <!-- <span>-{{item.amount}}元</span> -->
                                </div>
                                <div class="goods-sku">
                                    <span>整箱(6瓶)</span>
                                    <span style="color:#3088f5;">-{{item.num}}(瓶)</span>
                                </div>
                                <!-- <div class="caigou-price">采购价：¥288.9/瓶</div> -->
                            </div>
                        </div>
                        <!-- 该种酒总数 -->
                        <div class="goods-total" style="text-align:left;">
                            <span class="total-num">订单号：{{item.orderNo}}</span>
                        </div>
                    </div>
                </div>
            </template>
            <!-- 数据为空 -->
            <van-empty v-show="list.length == 0" :image=nullImg description="暂无数据~" />
        </div>
        <!-- <div class="see-more">查看更多</div> -->
    </div>
</template>

<script>
import $http from '@/lib/request'
import config from '@/config'
import {Toast,Empty} from 'vant'

export default {
    data(){
        return {
            currentTab:1,//1 入库，2 出库
            list:[],
            totalNum:0,
            releaseNum:0,
            currentFilter:0,//0全部（为0时不用传），1 进货记录，2 兑换，3 销售奖励，4 出库
            nullImg:require('@/assets/icon-null.png'),
            maxPage:1,
            page:1,
            limit:10,
        }
    },
    components:{
        [Toast.name]:Toast,
        [Empty.name]:Empty
    },
    activated(){
        this.getData();
        window.addEventListener("scroll", this.scrollFn);
    },
    beforeDestroy(){
        window.removeEventListener("scroll", this.scrollFn);
    },
    methods:{
        scrollFn(){
            if (document.querySelector(".page-container").offsetHeight - window.pageYOffset - window.screen.height < 100 && this.page < this.maxPage) {
                this.page++;
                this.getData();
            }
        },
        changeTab(type){
            this.currentTab=type;
            this.list=[];
            this.getData();
        },
        changeFilter(type){
            this.currentFilter=type;
            this.list=[];
            this.getData();
        },
        getData(){
            let data={
                type:this.currentTab,
                page:this.page,
                limit:this.limit
            };
            if(this.currentFilter != 0){
                data.opType=this.currentFilter;
            }
            $http({
                method:'post',
                data:data,
                url:config.api.stockDetail
            }).then(res=>{
                if(res.errno == 0){
                    if(this.page == 1){
                        this.list=this.list=res.data.recordList;
                    }else{
                        this.list=this.list.concat(res.data.recordList);
                    }
                    this.maxPage=res.data.pages;
                    this.totalNum=res.data.totalNum;
                    this.releaseNum=res.data.releaseNum;
                }else{
                    Toast(res.errmsg);
                }
            })
        },
        jumpRk(orderId,opType){
            if(opType == 2){
                this.$router.push({
                    name:'redemption-detail',
                    params:{
                        orderId:orderId
                    }
                });
            }else{
                this.$router.push({
                    name:'purchase-detail',
                    params:{
                        orderId:orderId
                    }
                });
            }
        },
        jumpCk(orderId){
            this.$router.push({
                name:'pickup-detail',
                params:{
                    orderId:orderId
                }
            });
        }
    },
}
</script>

<style lang="scss" scoped>
@mixin flex-beteween{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
::v-deep .van-empty__image{
    width:140px;
    height:108px;
}
::v-deep .van-empty{
    margin-top: 50px;
}
.page-container{
    padding: 0 10px;
    background:#f5f5f5;
    min-height: 100vh;
    padding-top: 65px;
    box-sizing: border-box;
    .tabbox{
        position: fixed;
        background: #fff;
        top:0;
        left:0;
        width:100vw;
        height:65px;
        box-sizing: border-box;
        padding: 12px 38px;
        z-index: 9;
        .tabs{
            overflow: hidden;
            display: flex;
            align-items: flex-start;
            justify-content: center;
            .tab-item{
                width:50%;
                height:40px;
                line-height: 40px;
                text-align: center;
                font-size: 16px;
                color:#2172F6;
                box-sizing: border-box;
                border:1px solid #3088F5;
                &.actived{
                    color:#fff;
                    background: linear-gradient(180deg, #3CA7FE 0%, #3088F5 100%);
                    border:none;
                }
                &:first-child{
                    border-top-left-radius: 4px;
                    border-bottom-left-radius: 4px;
                    border-right: none;
                }
                &:last-child{
                    border-top-right-radius: 4px;
                    border-bottom-right-radius: 4px;
                    border-left: none;
                }
            }
        }
    }
    .record-types{
        padding:15px 0;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;
        .type-item{
            height:26px;
            line-height: 26px;
            padding:0 12px;
            color:#999;
            background: #fff;
            font-size: 13px;
            margin-right: 15px;
            &:last-child{
                margin-right: 0;
            }
            @media screen and (max-width: 750px){
                border-radius: 26px;
            }
            &.actived{
                background:#328DF7;
                color:#fff;
            }
        }
    }
    .referral-line{
        font-size: 14px;
        color:#666;
        line-height: 20px;
        &>span{
            margin-right: 20px;
        }
    }
    .page-bottom{
        padding:10px 0;
        .purchase-block{
            position: relative;
            .goods-bock{
                background:#fff;
                border-radius: 4px;
                padding:15px;
                padding-top: 0;
                box-sizing: border-box;
                margin-bottom: 10px;
                .item-top{
                    @include flex-beteween();
                    height:44px;
                    line-height: 44px;
                    color:#999;
                    border-bottom: 1px solid #f5f5f5;
                    .date{
                        font-size: 13px;
                    }
                    .status{
                        font-size: 14px;
                        &.fromSale{
                            color:#A030F5;
                        }
                        &.fromPickup{
                            color:#3088F5;
                        }
                    }
                }
                .goods-info-block{
                    display: flex;
                    justify-content: flex-start;
                    margin-top: 15px;
                    .goods-pic{
                        width:70px;
                        height:70px;
                        margin-right: 10px;
                        border-radius: 4px;
                    }
                    .goods-detail{
                        display: flex;
                        flex-direction: column;
                        justify-content: flex-start;
                        width:calc(100% - 70px);
                        .goods-name{
                            margin-bottom: 10px;
                            &>span:first-child{
                                overflow: hidden;
                                text-overflow:ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;
                            }
                            @include flex-beteween();
                            color:#333;
                            line-height: 20px;
                            font-size: 14px;
                        }
                        .goods-sku{
                            @include flex-beteween();
                            color:#999;
                            line-height: 18px;
                            font-size: 12px;
                        }
                        .caigou-price{
                            color:#999;
                            line-height: 18px;
                            font-size: 12px;
                        }
                    }
                }
                .presentation-block{
                    position: relative;
                    margin-top: 30px;
                    @include flex-beteween();
                    .present-left{
                        width:280px;
                        display: flex;
                        justify-content: flex-start;
                        align-items: flex-start;
                        .goods-pic{
                            width:70px;
                            height:70px;
                            border-radius: 4px;
                            overflow: hidden;
                            position: relative;
                            margin-right: 10px;
                            &>img{
                                display: block;
                                width:100%;
                                height:100%;
                            }
                            .tag{
                                padding:0 5px;
                                height:18px;
                                line-height: 18px;
                                background:#E43D3D;
                                color:#fff;
                                border-bottom-right-radius: 4px;
                                position: absolute;
                                top:0;
                                left:0;
                                font-size: 10px;
                            }
                        }
                        .goods-info{
                            width:220px;
                            height:50px;
                            display: flex;
                            justify-content: space-between;
                            flex-direction: column;
                            .goods-name{
                                font-size: 12px;
                                color:#000;
                                line-height: 18px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }
                            .sku{
                                color:#999;
                                font-size: 10px;
                                line-height: 14px;
                            }
                        }
                    }
                    .present-right{
                        width:50px;
                        height:50px;
                        line-height: 50px;
                        font-size: 12px;
                        color: #999;
                        text-align: right;
                        position: relative;
                        border-left:1px solid #d8d8d8;
                        // &::after{
                        //     position: absolute;
                        //     top:10px;
                        //     left:0;
                        //     content:'';
                        //     display: block;
                        //     height:40px;
                        //     width:1px;
                        //     box-shadow: -1px 0px 3px 1px #d8d8d8;
                        //     background:transparent;
                        // }
                    }
                }
                .goods-total{
                    border-top: 1px solid #f5f5f5;
                    font-size: 14px;
                    color:#999;
                    text-align: right;
                    margin-top: 15px;
                    padding-top: 15px;
                    .total-num{
                        color:#999;

                    }
                }
            }
        }
        .see-account{
            color:#000;
            font-size: 16px;
            line-height: 22px;
            margin-top: 25px;
        }
    }
    .see-more{
        padding:10px;
        line-height: 18px;
        color:#999;
        text-align: right;
        font-size: 12px;
    }
}
</style>